import { render, staticRenderFns } from "./SpaceIntroduce.vue?vue&type=template&id=fd9fa58a&scoped=true&"
import script from "./SpaceIntroduce.vue?vue&type=script&lang=ts&"
export * from "./SpaceIntroduce.vue?vue&type=script&lang=ts&"
import style0 from "./SpaceIntroduce.vue?vue&type=style&index=0&id=fd9fa58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9fa58a",
  null
  
)

export default component.exports